/* eslint-disable no-useless-catch */
import * as fetchService from '../../../../sharedmodules/services/fetch';

const basePath = '/api';

const headerOptions = (accessToken) => ({
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
});

export async function pinTransferStatusUpdate(getAccessToken, pinTransferRequest) {

    const endPoint = `${basePath}/admin/transfers/`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
        },
        body: JSON.stringify(pinTransferRequest),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        throw error;

    }

}
